import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './CategorizedLinks.styled';

/**
 * Links to appear in the footer
 */
const CategorizedLinks = ({ title, links }) => (
  <>
    <Styled.Title>{title}</Styled.Title>
    <Styled.List>
      {links.map((link, index) => (
        <Styled.ListItem key={index}>
          <Styled.Link href={link.url}>{link.text}</Styled.Link>
        </Styled.ListItem>
      ))}
    </Styled.List>
  </>
);

CategorizedLinks.propTypes = {
  /**
   * Title to appear at the top of a list of links
   */
  title: PropTypes.string,
  /**
   * Array containing link names and corresponding URLs
   */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  )
};

CategorizedLinks.defaultProps = {
  title: undefined,
  links: undefined
};

export default CategorizedLinks;
